export default __webpack_public_path__ + "static/media/dis-02@2x.a4259ed7.jpg";